import { render, staticRenderFns } from "./studentquestionanswer.vue?vue&type=template&id=312cc92d&scoped=true"
import script from "./studentquestionanswer.vue?vue&type=script&lang=js"
export * from "./studentquestionanswer.vue?vue&type=script&lang=js"
import style0 from "./studentquestionanswer.vue?vue&type=style&index=0&id=312cc92d&prod&lang=css"
import style1 from "./studentquestionanswer.vue?vue&type=style&index=1&id=312cc92d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312cc92d",
  null
  
)

export default component.exports